/*
 * @Author: mina.min
 * @Date: 2025-01-20 10:00:00
 * @LastEditors: mina.min
 * @LastEditTime: 2025-06-11 11:46:36
 * @FilePath: /OTAManagementSystem/src/pages/DeviceManagement/index.tsx
 * @Description: 设备管理主页面
 */
import React from 'react'
import DeviceList from './DeviceList'

const DeviceManagement: React.FC = () => {
  return <DeviceList />
}

export default DeviceManagement
